import React, { useEffect, useState } from "react"
import { formatShortDate } from "src/shared/helpers/formatShortDate"
import { isDateDiffOneDayOrMore } from "src/shared/helpers/isDateDiffOneDayOrMore"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./Reserved.css"
import { useDate } from "src/shared/hooks/useDate"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"

const Reserved = ({
    roomNumber,
    reservedDetails,
    roomTypeName,
    reservedEndDate = "",
    reservedStartDate = "",
    reservedClientName,
    hasIncidences,
    reservedPeopleNum = 0,
    reservedCheckOutDate,
    gestIn = false,
}: Omit<RoomStatusProps, "roomStatus">) => {
    const { UTCStringToLocalDate } = useDate()
    const { nowHotel } = useFormatDate()

    const [isReservedForOneOrMoreDays, setisReservedForOneOrMoreDays] = useState(
        isDateDiffOneDayOrMore(UTCStringToLocalDate(reservedStartDate), UTCStringToLocalDate(reservedEndDate))
    )

    const [now] = useTimePulse()

    const [isNoShow, setisNoShow] = useState(false)
    const [noShowDate, setNoShowDate] = useState(0)

    useEffect(() => {
        setNoShowDate((reservedCheckOutDate || new Date()).getTime() + 60 * 1000)
    }, [reservedCheckOutDate])

    useEffect(() => {
        if (!noShowDate) return
        const noShowTime = new Date(noShowDate).getTime()
        if (isNaN(noShowTime)) return
        if (nowHotel.getTime() > noShowTime) {
            setisNoShow(true)
        } else {
            setisNoShow(false)
        }
    }, [nowHotel, noShowDate])

    useEffect(() => {
        setisReservedForOneOrMoreDays(
            isDateDiffOneDayOrMore(UTCStringToLocalDate(reservedStartDate), UTCStringToLocalDate(reservedEndDate))
        )
    }, [reservedStartDate, reservedEndDate])
    return (
        <Wrapper hasIncidences={hasIncidences}>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                iconName={UTCStringToLocalDate(reservedStartDate) <= now ? "calendarCross" : "calendar"}
                iconBgColor="var(--purple-drawer-primario)"
                roomNumber={roomNumber}
            />
            <RoomCardBody>
                {!isNoShow && <span className="room-card--sm--reserved__gest-name">{reservedClientName}</span>}
                <div className="room-card--sm--reserved__description">
                    {isReservedForOneOrMoreDays
                        ? `${formatShortDate(UTCStringToLocalDate(reservedStartDate))} - 
                    ${formatShortDate(UTCStringToLocalDate(reservedEndDate))}`
                        : formatShortDate(UTCStringToLocalDate(reservedStartDate))}
                </div>
                <span className="room-card--sm--reserved__description">{roomTypeName}</span>
                {isNoShow && (
                    <>
                        <span className="room-card--sm--reserved__no-show">No show</span>
                    </>
                )}
            </RoomCardBody>
        </Wrapper>
    )
}

export default Reserved
